import { RootState } from "../types";

export const stateSelector = (state: RootState) => state;
export const accessTokenSelector = (state: RootState) => state.user.accessToken;
export const refreshTokenSelector = (state: RootState) =>
  state.user.refreshToken;
export const isAuthSelector = (state: RootState) => state.user.isAuth;
export const errorUserSelector = (state: RootState) => state.user.error;
export const errorTimeStampSelector = (state: RootState) => state.user.retryAfterTimestamp;
export const isChargingCustomersSelector = (state: RootState) => state.user.isChargingCustomers;
export const isRecordingInProgressSelector = (state: RootState) => state.user.isRecordingInProgress;
export const therapistsCanSeePricesSelector = (state: RootState) => state.user.therapistsCanSeePrices;
export const canAddDefaultReportsSelector = (state: RootState) => state.user.canAddDefaultReports;
